module.exports = __webpack_public_path__ + "static/osteopathie1-0c92de7d6feca4fd4ec389bc180d28c6.jpg";